import { point } from "./point";

import { EVENT_SOURCE_WINDOW } from "../../view/constants";

export default function getExtendedEvents(view, event, item, type, source) {
    if (source === EVENT_SOURCE_WINDOW) {
        const e = event.changedTouches ? event.changedTouches[0] : event;
        point(e);
    }
    return event.element = item, event;
}
//# sourceMappingURL=events-extend.js.map
